import { mapApi } from '@shared/api/server'

import { ClustersDto, LayerSizeType } from '../types'
import { ClusterModel } from './cluster.model'

export interface IClusterRepository {
  getClusterList(payload: ClustersDto): Promise<ClusterModel[]>
}

export class ClusterRepository implements IClusterRepository {
  async getClusterList(payload: ClustersDto): Promise<ClusterModel[]> {
    const list = await mapApi.getClustersCall(payload)
    if (!list) {
      return []
    }
    return list.map(
      (item) =>
        new ClusterModel(
          item.id,
          item.sizeName as LayerSizeType,
          item.coordinates,
          item.titleSize,
          item.circleWeight,
          item.circleRadius,
          item.targetOpacity,
          item.pointsCount
        )
    )
  }
}
